export default [
  { role: 'ROLE_CTO_ADMIN', name: 'Администратор ЦТО' },
  { role: 'ROLE_CTO_EMPLOYEE', name: 'Сотрудник ЦТО' }
]
